import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { LOGIN_PATH } from 'modules/payroll_integrations_a3innuva/lib/OauthService'

interface Props {
  companyId: number
  organizationalUnitId: string
}

interface LogInProps {
  companyId: number
  accessId: number
}

export const NotAuthenticated = ({ companyId, organizationalUnitId }: Props) => {
  return (
    <Box>
      <Alert color="warning">
        <Box flexDirection="column" gap="s8">
          <Text.Normal>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.not_authenticated'
            )}
          </Text.Normal>
          <Button
            onClick={() => {
              window.location.href = buildUrl(
                `${LOGIN_PATH}/?company_id=${companyId}&organizational_unit_id=${organizationalUnitId}`
              )
            }}
          >
            {i18n.t('payroll_integrations.oauth.banner.link')}
          </Button>
        </Box>
      </Alert>
    </Box>
  )
}

export const NotLoggedIn = ({ companyId, accessId }: LogInProps) => {
  return (
    <Box gap="s24">
      <Button
        onClick={() => {
          track(trackingEvents.payrollIntegrationsA3Innuva.a3innuvaSettingsLogin, {
            company_id: companyId,
            access_id: accessId,
          })
          window.location.href = buildUrl(LOGIN_PATH)
        }}
      >
        {i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status_card.button'
        )}
      </Button>
      <Box gap="s6">
        <Text.Normal>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.description.footer'
          )}
        </Text.Normal>
        <Box component="ul" paddingLeft="s24" style={{ listStyle: 'disc' }}>
          <Box component="li" style={{ display: 'list-item' }}>
            <Text.Normal>
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.description.requirement_1'
              )}
            </Text.Normal>
          </Box>
          <Box component="li" style={{ display: 'list-item' }}>
            <Text.Normal>
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.description.requirement_2'
              )}
            </Text.Normal>
          </Box>
          <Box component="li" style={{ display: 'list-item' }}>
            <Text.Normal>
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.description.requirement_3'
              )}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
